import { render } from "./EmailAddressPage.vue?vue&type=template&id=59b69f4a&scoped=true"
import script from "./EmailAddressPage.vue?vue&type=script&lang=js"
export * from "./EmailAddressPage.vue?vue&type=script&lang=js"

import "./EmailAddressPage.vue?vue&type=style&index=0&id=59b69f4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b69f4a"]])

export default __exports__